import { useMemo } from 'react';
import { useActiveCircle } from '../use-active-circle';

export default function usePlanPermissions() {
    const { hasPermission } = useActiveCircle();
    return useMemo(
        () => ({
            /**
             * TODO this is a placeholder Required permissions to get plans
             */
            canView: hasPermission('circle', 'r'),
        }),
        [hasPermission]
    );
}
